module.exports = __webpack_public_path__ + "static/media/promote_03.9164f190.png";